import TktUser from './TktUser';
import moment from 'moment';
import { Utils } from '../services';

/** Class representing a customer. */
class Customer extends TktUser {
    constructor(properties) {
        super(properties);

        this.roles = this.roles || [];
        if (!this.roles.includes('customer'))
            this.roles.push('customer');
    }

    avatarUrl() {
        if (!this.avatar)
            return null;

        return Utils.imgProxyUrl(`${this.avatar}?t=${moment(this.updated_at).toISOString()}`);
    }
}

export default Customer;
